import { render, staticRenderFns } from "./CircuitAddOrEditStep2.vue?vue&type=template&id=06483475&scoped=true&"
import script from "./CircuitAddOrEditStep2.vue?vue&type=script&lang=ts&"
export * from "./CircuitAddOrEditStep2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06483475",
  null
  
)

export default component.exports